import { get$, put$, delete$ } from "./default";
import { api } from "../constants/api";

export const getUserEditableTemplatesAPI = () => {
  return get$(api.userEmailTemplates.list);
};

export const getUserEditableTemplateAPI = (templateKey) => {
  const url = api.userEmailTemplates.detail.replace(":templateKey", encodeURIComponent(templateKey));
  return get$(url);
};

export const saveUserEditableTemplateAPI = (templateKey, body, name, subject) => {
  const url = api.userEmailTemplates.detail.replace(":templateKey", encodeURIComponent(templateKey));
  const payload = { body, name: name ?? "" };
  if (subject !== undefined) {
    payload.subject = subject ?? "";
  }
  return put$(url, payload);
};

export const saveUserEmailTemplateOrderAPI = (order) => {
  return put$(api.userEmailTemplates.order, { order });
};

export const resetUserEditableTemplateAPI = (templateKey) => {
  const url = api.userEmailTemplates.detail.replace(":templateKey", encodeURIComponent(templateKey));
  return delete$(url);
};
